// Region selection init
var productType = $('.temp_information').data('product-type');
const baGradeSelector =
  'reward_form_submission_submission_data_ba_grade_options'; // 1st level
const baClassSelector =
  'reward_form_submission_submission_data_ba_class_options'; // 2nd level
const baScheduleSelector =
  'reward_form_submission_submission_data_ba_schedule_options'; // 3rd level

loadClassList(baClassSelector, '', true);
loadScheduleList(baScheduleSelector, '', true);

const $formSelectGrade = $('#' + baGradeSelector);
$formSelectGrade.on('change', function() {
  let selectedGrade = $formSelectGrade.find('option:selected').val();
  $('#' + baClassSelector).empty();
  loadClassList(baClassSelector, selectedGrade, false);
});

const $formSelectClass = $('#' + baClassSelector);
$formSelectClass.on('change', function() {
  let selectedClass = $formSelectClass.find('option:selected').val();
  let selectedGrade = $formSelectGrade.find('option:selected').val();
  $('#' + baScheduleSelector).empty();
  loadScheduleList(baScheduleSelector, selectedGrade, selectedClass, false);
});

function loadClassList(selectID, gradeSerial, readonly) {
  const $select2Selector = $('#' + selectID);
  $select2Selector.select2({
    theme: 'bootstrap',
    ajax: {
      type: 'get',
      url:
        '/api/v1/brainacademy/classes?product_type=' +
        productType +
        '&grade_serial=' +
        gradeSerial,
      dataType: 'json',
      data: function(params) {
        return {
          searchTerm: params.term, // search term
        };
      },
      processResults: function(data) {
        let classData = data.data;
        return {
          results: $.map(classData, function(item) {
            return {
              text: item.title,
              id: item.value,
            };
          }),
        };
      },
    },
  });

  $select2Selector.prop('readonly', readonly);
}

function loadScheduleList(selectID, gradeSerial, classSerial, readonly) {
  const $select2Selector = $('#' + selectID);
  $select2Selector.select2({
    theme: 'bootstrap',
    escapeMarkup: function(markup) {
      return markup;
    },
    templateResult: function(data) {
      return data.html;
    },
    templateSelection: function(data) {
      return data.text;
    },
    ajax: {
      type: 'get',
      url:
        '/api/v1/brainacademy/schedules?product_type=' +
        productType +
        '&grade_serial=' +
        gradeSerial +
        '&class_serial=' +
        classSerial,
      dataType: 'json',
      data: function(params) {
        return {
          searchTerm: params.term, // search term
        };
      },
      processResults: function(data) {
        let classData = data.data;
        return {
          results: $.map(classData, function(item) {
            return {
              html: item.html,
              text: item.title,
              id: item.value,
            };
          }),
        };
      },
    },
  });

  $select2Selector.prop('readonly', readonly);
}
